import { render, staticRenderFns } from "./WillExpire.vue?vue&type=template&id=16193464&scoped=true"
import script from "./WillExpire.vue?vue&type=script&lang=js"
export * from "./WillExpire.vue?vue&type=script&lang=js"
import style0 from "./WillExpire.vue?vue&type=style&index=0&id=16193464&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16193464",
  null
  
)

export default component.exports